<div class="container pt-3 nav-footer">
  <div class="row mt-3">
    <div class="col col-12 col-lg-8">
      <div class="d-flex flex-column flex-md-row justify-content-center justify-content-lg-start align-items-center h-100">
        @if (!externalContactLink) {
          <a class="flex-shrink-0 mx-3" [routerLink]="['/content']" [queryParams]="{ parent: 'Contact' }"><h4 i18n="@@NavFooterMenuContactLink">Contact</h4></a>
        }
        @if (externalContactLink) {
          <a class="flex-shrink-0 mx-3" [href]="externalContactLink" target="_blank" rel="noopener noreferrer nofollow"><h4 i18n="@@NavFooterMenuContactLink">Contact</h4></a>
        }
        @if (footerMenuContactRequestLink) {
          <a class="flex-shrink-0 mx-3" [routerLink]="['/contact-request']"><h4 i18n="@@NavFooterMenuContactRequestLink">Contact request</h4></a>
        }
        @if (!isAuthenticated) {
          <a class="flex-shrink-0 mx-3" [routerLink]="['/login']"><h4 i18n="@@NavFooterMenuLoginLink">Login</h4></a>
          @if (footerMenuRegisterLink) {
            <a class="flex-shrink-0 mx-3" [routerLink]="['/register']"><h4 i18n="@@NavFooterMenuRegisterLink">Register</h4></a>
          }
        }
        @if (isAuthenticated) {
          <a class="flex-shrink-0 mx-3" [routerLink]="['/login']" (click)="logout()"><h4 i18n="@@NavFooterMenuLogoutLink">Logout</h4></a>
        }
        @if (footerMenuShippingLink) {
          <a class="flex-shrink-0 mx-3" [routerLink]="['/content']" [queryParams]="{ parent: 'Shipping' }"><h4 i18n="@@NavFooterMenuShippingLink">Shipping</h4></a>
        }
      </div>
    </div>
    <div class="col col-lg-4 mt-3 mt-lg-0">
      <app-social-icons></app-social-icons>
    </div>
  </div>

  <div class="row flex-column-reverse flex-lg-row align-items-center mt-3 mb-4">
    <div class="col col-12 col-lg-4">
      <div class="d-flex justify-content-center justify-content-lg-start">
        <a class="text-muted ms-3" href="https://www.orga-soft.net" target="_blank" rel="noopener noreferrer nofollow"
          ><img role="img" class="osbk-logo" alt="OSBK logo" /><span class="osbk 1 ms-1">ORGA-SOFT INTEGRA GmbH © 2021-{{ currentYear }}</span></a
        >
      </div>
    </div>
    <div class="col col-12 col-lg-4 text-center my-4 my-lg-0">
      <img role="img" class="brand-logo" [alt]="brand + ' logo'" />
      <span class="brand-name">{{ brand }}</span>
    </div>
    <div class="col col-12 col-lg-4">
      <div class="d-flex flex-column flex-md-row justify-content-center justify-content-lg-end align-items-center">
        @if (!externalLegalLinks) {
          <a class="flex-shrink-0 text-muted mx-3" [routerLink]="['/content']" [queryParams]="{ parent: 'Terms' }" i18n="@@NavFooterMenuTermsLink">Terms</a>
          <a class="flex-shrink-0 text-muted mx-3" [routerLink]="['/content']" [queryParams]="{ parent: 'Imprint' }" i18n="@@NavFooterMenuImprintLink">Imprint</a>
          <a class="flex-shrink-0 text-muted mx-3" [routerLink]="['/content']" [queryParams]="{ parent: 'DataProtection' }" i18n="@@NavFooterMenuDataProtectionLink">Data protection</a>
        }
        @if (externalLegalLinks) {
          <a class="flex-shrink-0 text-muted mx-3" [href]="externalLegalLinks.terms" target="_blank" rel="noopener noreferrer nofollow" i18n="@@NavFooterMenuTermsLink">Terms</a>
          <a class="flex-shrink-0 text-muted mx-3" [href]="externalLegalLinks.imprint" target="_blank" rel="noopener noreferrer nofollow" i18n="@@NavFooterMenuImprintLink">Imprint</a>
          <a class="flex-shrink-0 text-muted mx-3" [href]="externalLegalLinks.dataProtection" target="_blank" rel="noopener noreferrer nofollow" i18n="@@NavFooterMenuDataProtectionLink">Data protection</a>
        }
      </div>
    </div>
  </div>
</div>
